// Components
import Cards from '@/components/global-components/cards/Cards';
import TopBanner from '@/components/global-components/top-banner/TopBanner';
import Location from '@/components/global-components/locations/Location';
import Container from '@/components/global-components/Container';
import Banner from '@/components/global-components/banner/Banner';
import StyledCard from '@/components/global-components/styled-card/StyledCard';
import Highlights from './highlights/Highlights';
import AlliancesBanner from './alliances/AlliancesBanner';

// Themes
import theme from '@/themes/index';

// Services
import { getPerfectLocationsContent } from '@/graphql/why-costa-rica';

const WhyCostaRicaBody = ({
  content,
  isMobile,
  isTablet,
  isDesktop,
}) => {
  let style = {
    height: '27.75rem', padding: '8rem 1rem 4rem',
  };
  if (isTablet) {
    style = {
      height: '19.75rem', paddingTop: '4.75rem',
    };
  } else if (!isMobile) {
    style = {
      height: '33.75rem', paddingTop: '8.75rem',
    };
  }

  return (
    <>
      <section>
        <TopBanner {...content.topBanner} style={style} />
      </section>
      <section className="about-cpi">
        <Container>
          <Location
            {...content.aboutCpi}
            style={isDesktop ? {
              height: '30.5rem', 
            } : {}}
            imageStyle={
              isMobile
                ? {
                  height: '14.5rem', width: '16rem', 
                }
                : {
                  height: '30.5rem', width: '34rem', 
                }
            }
            locationDetailsStyle={
              isDesktop ? {
                height: '30.5rem', paddingTop: '0', 
              } : {}
            }
            secondaryCtaStyle={
              !isMobile
                ? {
                  width: '13.875rem', maxWidth: 'inherit', 
                }
                : {
                  maxWidth: 'inherit', 
                }
            }
          />
        </Container>
      </section>
      <section className="highlights">
        <Highlights
          isMobile={isMobile}
          isDesktop={isDesktop}
          content={content.costaRicaHighlights}
        />
      </section>
      <section>
        <Banner content={content.banner}></Banner>
      </section>
      <section className="about-us">
        <div className='figure pura-vida-figure'>
          <img src={'/assets/images/Asset_1.png'}/>
        </div>
        <Container>
          <StyledCard content={content.aboutUs} isDesktop={isDesktop} />
        </Container>
      </section>
      <section className="perfect-locations">
        <Container>
          <Cards
            isMobile={isMobile}
            isDesktop={isDesktop}
            content={getPerfectLocationsContent(content)}
          />
        </Container>
      </section>
      <section className="alliances-banner">
        <div className='figure left-figure'>
          <img src={'/assets/images/icon_whycr_1.svg'}/>
        </div>
        <AlliancesBanner content={content.alliancesBanner} />
        <div className='figure right-figure'>
          <img src={'/assets/images/icon_whycr_1.svg'}/>
        </div>
      </section>
      <section className="social-responsibility-us">
        <Container>
          <StyledCard
            content={content.socialResponsibility}
            isDesktop={isDesktop}
            containerStyle={{
              flexDirection: 'column-reverse', 
            }}
            infoContainerStyle={isDesktop ? {
              textAlign: 'center',
              paddingRight: 0,
            } : {}}
            infoButtonStyle={isDesktop ? {
              margin: '0 auto', 
            } : {}}
            imageStyle={isDesktop ? {
              width: '100%', 
            } : {}}
          />
        </Container>
      </section>
      <style jsx>{`
        section.perfect-locations,
        section.social-responsibility-us,
        section.about-cpi,
        section.about-us {
          margin: 3rem 2rem ;
        }

        section.highlights {
          padding: 0 2rem;
        }

        section.about-cpi .container {
          justify-content: center;
        }

        section.alliances-banner {
          margin: 5rem 0;
          text-align: center;
        }

        section.alliances-banner div.figure {
          display: none;
        }
        section.about-us .figure{
          z-index: -1;
          top: -8rem;
          right: 3%;
          width: 300px;
          -webkit-flex-flow: row-reverse;
          -ms-flex-flow: row-reverse;
          flex-flow: row-reverse;
          position: absolute;
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex;
          margin: 0 auto;
        }

        section.about-us.figure img{
          width: 100%;
        }
        
        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          section.alliances-banner {
            margin: 5rem 0 6rem;
            position: relative;
          }

          section.alliances-banner div.figure {
            position: absolute;
            display: flex;
            width: 100%;
            margin: 0 auto;
          }

          section.alliances-banner div.left-figure {
            top: -4rem;
            flex-flow: row;
            padding-left: 3%;
          }

          section.alliances-banner div.right-figure {
            flex-flow: row;
            padding-left: 3%;
            bottom: -8.5rem;
            transform: matrix(-1, 0, 0, -1, 0, 0);
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.alliances-banner {
            margin: 5rem 0;
          }

          section.perfect-locations,
          section.social-responsibility-us,
          section.about-cpi,
          section.about-us {
            margin: 5rem 4.5rem ;
          }

          section.highlights {
            padding: 0 4.5rem;
          }
        }
      `}</style>
      <style global jsx>{`
        section.perfect-locations div.cta-container  {
          gap: 1rem;
        }

        section.social-responsibility-us .container .info-container {
          padding: 0;
        }

        section.social-responsibility-us .container .info-container .default-card-content p {
          text-align: center;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section.perfect-locations div.cta-container  {
            padding: 0;
          }
        }
      `}</style>
    </>
  );
};

export default WhyCostaRicaBody;
